var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"backToTop w-10 h-10",attrs:{"href":"#header"}})])
}]

export { render, staticRenderFns }